module.exports = __webpack_public_path__ + "img/gift9.96b11c1f.png";